export default "__VITE_ASSET__eDREGji5__"